import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  const convertCode = () => {
    navigate('/convert');
  };

  return (
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Translate Code Effortlessly</h1>
          <p className="hero-description">
            Use AI to instantly translate code between programming languages.
          </p>
          <button className="convert-btn" onClick={convertCode}>
            Convert
          </button>
        </div>
      </section>
  );
};

export default Hero;
